import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PanelContainerComponent } from '../@shared/panel-container/panel-container.component';
import { PanelHeaderComponent } from '../@shared/panel-header/panel-header.component';
import { AsyncPipe, JsonPipe } from '@angular/common';
import { TsTableComponent } from 'tsui/lib/ts-table';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { filter, map, Observable } from 'rxjs';
import { RelatedToType } from '@shared/enums';
import { JupiterState } from 'app/modules/jupiter/@store/state';
import { FieldDefsState } from '@state/fields/state';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LOAN_QUOTE_STATES } from 'app/modules/projects/details/loans/loans.service';
import { EntityActions } from 'app/modules/jupiter/@store/actions';
import { JupiterPanelComponent } from '../jupiter-panel.component';

@Component({
  selector: 'jupiter-crm-data-table-panel',
  standalone: true,
  imports: [PanelContainerComponent, PanelHeaderComponent, AsyncPipe, TsTableComponent, JsonPipe],
  templateUrl: './crm-data-table-panel.component.html',
  styleUrl: './crm-data-table-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterCrmDataTablePanelComponent extends JupiterPanelComponent<any> implements OnInit {
  columnDefs: any[] = [];
  items$: Observable<any>;
  data$ = this.store.select(FieldDefsState.getDropdownOptions).pipe(
    takeUntilDestroyed(this.destroyRef),
    map((options) => ({ options })),
  );

  ngOnInit(): void {
    super.ngOnInit();

    this.columnDefs = this.store
      .selectSnapshot(ObjectsManagerState.getFieldsByObjectName(this.panelDef.meta.related_to_type))
      .filter((x) => this.panelDef.meta.fields.includes(x.name));

    switch (this.panelDef.meta.related_to_type) {
      case RelatedToType.Project:
        this.store.dispatch(new EntityActions.DealActions.Load());
        this.items$ = this.store.select(JupiterState.getDealsItems);
        break;
      case RelatedToType.Property:
        this.store.dispatch(new EntityActions.PropertyActions.Load());
        this.items$ = this.store.select(JupiterState.getPropertiesItems);
        break;
      case RelatedToType.Contact:
        this.store.dispatch(new EntityActions.ContactActions.Load());
        this.items$ = this.store.select(JupiterState.getContactsItems);
        break;
      case RelatedToType.LoanQuote:
        this.columnDefs = [
          {
            name: 'workflow_state',
            label: 'State',
            type: 'string',
          },
          {
            name: 'deal_name',
            label: 'Deal Name',
            type: 'string',
          },
        ];
        this.store.dispatch(new EntityActions.LoanQuoteActions.Load());
        this.items$ = this.store.select(JupiterState.getLoanQuotesItems).pipe(
          filter((items) => !!items),
          map((items) => {
            return items.map((item) => ({
              ...item,
              workflow_state: LOAN_QUOTE_STATES.find((state) => state.key === item.workflow_state)?.label,
              deal_name: item.project?.title,
            }));
          }),
        );
        break;
    }

    this.items$ = this.items$.pipe(takeUntilDestroyed(this.destroyRef));
  }
}
